import type { FC } from "react";

import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { Icon } from "../../../../Icon";
import { createDisplayNameForButtonCircleElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCircleElement } from "../../utils/getTestId";

import type { IconProps } from "../../../../Icon";

type ButtonCircleIconProps = Omit<IconProps, "size"> & {
    containerSize?: string;
};

const name = "Icon";
const displayName = createDisplayNameForButtonCircleElement(name);
const testId = createTestIdForButtonCircleElement(name);

const ButtonCircleIcon = createComponentPreset<FC<ButtonCircleIconProps>>(
    displayName,
    Icon,
    // @ts-expect-error решаем проблему необходимости прокидывания testId на сложно сужаемый prop icon
    {
        "data-tsid": testId,
    } as ButtonCircleIconProps,
);

export default ButtonCircleIcon;
